import React, { FunctionComponent, ReactElement, memo } from 'react'
import BigTeaserSkeleton from '@sport1/news-styleguide/BigTeaserSkeleton'
import VerticalSpacer from '@sport1/news-styleguide/VerticalSpacer'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'

const BasicTeaserSkeleton: FunctionComponent = (): ReactElement => {
    const testId = 'basic-teaser-card-skeleton'
    return (
        <NonFlexingContainer testID={testId} backgroundColor="pearl">
            <VerticalSpacer
                space="standard"
                testID={`${testId}-vertical-spacer-0`}
                backgroundColor="pearl"
            />
            <BigTeaserSkeleton testID={`${testId}-big`} />
            <VerticalSpacer
                space="standard"
                backgroundColor="pearl"
                testID={`${testId}-vertical-spacer-1`}
            />
        </NonFlexingContainer>
    )
}

export default memo(BasicTeaserSkeleton)
